export default "__VITE_ASSET__d6159a25__"